import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms'
import { LearnerService } from '../../services/learner.service';
import { UserRoleService } from '../../services/user-role.service';
import { DocumentService } from '../../services/document.service';
import { UtilityService } from '../../services/utility.service';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
@Component({
  selector: 'app-assessment-checklist',
  templateUrl: './assessment-checklist.component.html',
  styleUrls: ['./assessment-checklist.component.scss']
})
export class AssessmentChecklistComponent implements OnInit {

  @Input('job') singleJob;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentEdit;
  @Input('learnerId') currentLearner

  assesmentCheckListForm: any
  assesmentCheckListFormEdit: any
  learnerData: any
  learnerName: any;
  jobData: any;
  isIQA: boolean = false;
  isLearner = false
  isAdmin = false
  isTrainer = false
  loading = false
  signature = false

  constructor(
    public _learnerService: LearnerService,
    public _userRoleService: UserRoleService,
    public _documentService: DocumentService,
    public _utilityService: UtilityService
  ) { }

  ngOnInit() {
  }


  ngOnChanges(changes: SimpleChanges): void {

    if (changes.singleLearner && changes.singleLearner.currentValue) {
      this.learnerData = changes.singleLearner.currentValue
      this.learnerName = this.learnerData.name
    }
    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobData = changes.singleJob.currentValue[0]
      this.getUserRole();
    }
    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      this.assesmentCheckListFormEdit = changes.assessmentEdit.currentValue
      let size = Object.keys(this.assesmentCheckListFormEdit).length;
      if (size != 0) {
        if (this.assesmentCheckListFormEdit.assesmentCheckListForm && this.assesmentCheckListFormEdit.assesmentCheckListForm.assesorSign && this.assesmentCheckListFormEdit.assesmentCheckListForm.assesorSign != "") {
          this.signature = true
        }
        this.createChecklistForm('test2', this.assesmentCheckListFormEdit)
      }
    } else this.createChecklistForm('test3', {})
  }

  // FORM CONTROL

  createChecklistForm(type, details?) {
    console.log("What is details", type, details);

    this.assesmentCheckListForm = new FormGroup({
      learnerName: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.learnerName : this.learnerName),
      learnerNo: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.learnerNo : ''),
      date: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.date : ''),
      attemptNo: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.attemptNo : ''),
      assesmentPass1: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass1 : ''),
      assesmentRefer1: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer1 : ''),
      assesmentPass2: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass2 : ''),
      assesmentRefer2: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer2 : ''),
      assesmentPass3: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass3 : ''),
      assesmentRefer3: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer3 : ''),
      assesmentPass4: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass4 : ''),
      assesmentRefer4: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer4 : ''),
      assesmentPass5: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass5 : ''),
      assesmentRefer5: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer5 : ''),
      assesmentPass6: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass6 : ''),
      assesmentRefer6: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer6 : ''),
      assesmentPass7: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass7 : ''),
      assesmentRefer7: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer7 : ''),
      assesmentPass8: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass8 : ''),
      assesmentRefer8: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer8 : ''),
      assesmentPass9: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass9 : ''),
      assesmentRefer9: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer9 : ''),
      assesmentPass10: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass10 : ''),
      assesmentRefer10: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer10 : ''),
      assesmentPass11: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass11 : ''),
      assesmentRefer11: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer11 : ''),
      assesmentPass12: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass12 : ''),
      assesmentRefer12: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer12 : ''),
      assesmentPass13: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass13 : ''),
      assesmentRefer13: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer13 : ''),
      assesmentPass14: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass14 : ''),
      assesmentRefer14: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer14 : ''),
      assesmentPass15: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass15 : ''),
      assesmentRefer15: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer15 : ''),
      assesmentPass16: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass16 : ''),
      assesmentRefer16: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer16 : ''),
      assesmentPass17: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass17 : ''),
      assesmentRefer17: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer17 : ''),
      assesmentPass18: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentPass18 : ''),
      assesmentRefer18: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentRefer18 : ''),
      assesorSign: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesorSign : ''),
      assesorDate: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesorDate : ''),
      assesmentInput: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.assesmentInput : ''),
      achievedInput: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.achievedInput : ''),
      referredInput: new FormControl((details && details.assesmentCheckListForm) ? details.assesmentCheckListForm.referredInput : '')
    })

  }


  // UTILITY

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);
    if (formGroup == 'assesmentCheckListForm') this.assesmentCheckListForm.get(formControl).setValue(value);
  }

  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.jobData.instructors, 'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true
  }


  addSignature() {
    console.log("Value of current user", this.isLearner, this.isIQA);

    if (this.isLearner) {
      this.assesmentCheckListForm.get('assesorSign').disable()
    } else if (this.isIQA) {
      this.assesmentCheckListForm.get('assesorSign').disable()
    } else {
      this._utilityService.commonDialogBoxOpen(SignaturePadComponent)
        .afterClosed().subscribe((res) => {
          if (res == undefined) return
          else
            this.signature = true
          this.assesmentCheckListForm.patchValue({
            assesorSign: res
          })
        })
    }
  }

  // API CALL


  assesmentCheckListSubmit() {
    console.log("Value of check list form", this.assesmentCheckListForm.value);

    let data = {
      learnerId: this.learnerData._id,
      jobId: this.jobData._id,
      version: true,
      details: {
        assesmentCheckListForm: this.assesmentCheckListForm.value,
      },
      // type: 'markingScheme'
    }
    this.loading = true
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      // this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this._utilityService.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" })
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("Marking Schema not accepted", err)
    })

  }

}
